import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
 name: 'stagione'
})

export class StagionePipe implements PipeTransform {
    /**
     * setta la stagione attraverso il parametro
     * @param  {number} value
     */
    transform(value: number ): string {
        if (value != null) {
            let valore:number = value * 1000;
            let data = new Date(valore);
            let datastr = data.getFullYear() + "-" + (data.getMonth() + 1) + "-" + data.getDay();
            if (this.checkEstate(datastr))
                return '<i class="far fa-sun" title="Estate"></i>';
            else if (this.checkPrimavera(datastr)) 
                return '<i class="fas fa-cloud-sun" title="Primavera"></i>';
            else if (this.checkInverno(datastr)) 
                return '<i class="far fa-snowflake" title="Inverno"></i>';
            else if (this.checkAutunno(datastr))
                return '<i class="fa fa-leaf" title="Autunno"></i>';
        }
        return "";
    }

    /**
     * controlla se il periodo è estivo
     * @param  {string} value
     */
    checkEstate(value: string): boolean {
        let dataodierna = new Date(value);
        let contenuta = false;
        let oggi = new Date();
        let start_date= new Date(oggi.getFullYear() + "-06-22");
        let end_date=new Date(oggi.getFullYear() + "-09-22");
        if ((dataodierna >= start_date ) && (dataodierna <= end_date)) 
            contenuta = true;
        return contenuta;
    }
    
    /**
     * controlla se il periodo è Inverno
     * @param  {string} value
     */
    checkInverno(value: string): boolean {
        let dataodierna = new Date(value);
        let contenuta = false;
        let oggi = new Date();
        let start_date= new Date(oggi.getFullYear() + "-12-23");
        let end_date=new Date(oggi.getFullYear() + "-03-20");
        if ((dataodierna >= start_date ) && (dataodierna <= end_date)) 
            contenuta = true;
        return contenuta;
    }

    /**
     * controlla se il periodo è Autunno
     * @param  {string} value
     */
    checkAutunno(value: string): boolean {
        let dataodierna = new Date(value);
        let contenuta = false;
        let oggi = new Date();
        let start_date= new Date(oggi.getFullYear() + "-09-23");
        let end_date=new Date(oggi.getFullYear() + "-12-22");
        if ((dataodierna >= start_date ) && (dataodierna <= end_date)) 
            contenuta = true;
        return contenuta;
    }


    /**
     * controlla se il periodo è Primavera
     * @param  {string} value
     */
    checkPrimavera(value: string): boolean {
        let dataodierna = new Date(value);
        let contenuta = false;
        let oggi = new Date();
        let start_date= new Date(oggi.getFullYear() + "-03-21");
        let end_date=new Date(oggi.getFullYear() + "-06-21");
        if ((dataodierna >= start_date ) && (dataodierna <= end_date)) 
            contenuta = true;
        return contenuta;
    }
}